import { render, staticRenderFns } from "./ShopDatesModal.vue?vue&type=template&id=c1b51a72&scoped=true&"
import script from "./ShopDatesModal.vue?vue&type=script&lang=js&"
export * from "./ShopDatesModal.vue?vue&type=script&lang=js&"
import style0 from "./ShopDatesModal.vue?vue&type=style&index=0&id=c1b51a72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1b51a72",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VCard,VCombobox,VDatePicker,VDialog,VIcon,VMenu})
